import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';

const REMOVE_CART_LINE_ITEMS = gql`
  mutation RemoveCartLineItems($cartInput: RemoveCartLineItemsInput!) {
    removeCartLineItems(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { REMOVE_CART_LINE_ITEMS };
//# sourceMappingURL=remove-cart-line-items.js.map
